import React from "react";
import { useOrganisations } from "../hooks/useOrganisations";
import { useRoles } from "../hooks/useRoles";
import { Spinner } from "../components/ui/Spinner";

export const DashboardPage: React.FC = () => {
  const { data: orgsData, isLoading: orgsLoading } = useOrganisations(1, 1, "");
  const { data: roles, isLoading: rolesLoading } = useRoles();

  return (
    <div>
      <h2 className="text-lg font-bold text-gray-800 mb-6">Overview</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-xl">
        <div className="bg-white border border-border-gray rounded p-6">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
            Organisations
          </p>
          {orgsLoading ? (
            <Spinner />
          ) : (
            <p className="text-3xl font-bold text-gray-800">{orgsData?.total ?? 0}</p>
          )}
        </div>
        <div className="bg-white border border-border-gray rounded p-6">
          <p className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-1">
            Roles
          </p>
          {rolesLoading ? (
            <Spinner />
          ) : (
            <p className="text-3xl font-bold text-gray-800">{roles?.length ?? 0}</p>
          )}
        </div>
      </div>
    </div>
  );
};
